import { render, staticRenderFns } from "./generate.vue?vue&type=template&id=57a0a0d3&scoped=true&"
import script from "./generate.vue?vue&type=script&lang=ts&"
export * from "./generate.vue?vue&type=script&lang=ts&"
import style0 from "./generate.vue?vue&type=style&index=0&id=57a0a0d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a0a0d3",
  null
  
)

export default component.exports